import React from "react";
import { FilterModalSelect } from "./FilterModalSelect";
import {
  ServiceProviderContact,
  useServiceProviderList,
} from "src/utils/CommonDataFetchingUtils/useServiceProviderList";

interface ServiceProviderFilterProps {
  assignedTo: string;
  setAssignedTo: (value: string) => void;
}

export const ServiceProviderFilter = ({
  assignedTo,
  setAssignedTo,
}: ServiceProviderFilterProps) => {
  const { serviceProviders } = useServiceProviderList();

  const options = serviceProviders.map((provider: ServiceProviderContact) => ({
    name: `${provider.firstname} ${provider.lastname}`,
    value: provider.id,
  }));

  return (
    <FilterModalSelect
      label="Assigned To"
      value={assignedTo}
      onChange={setAssignedTo}
      placeholderText="Select Assigned To"
      options={options}
    />
  );
};
